export function normalizeTimeLoose(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const match = trimmed.match(/^(\d{1,2}):(\d{2})/);
  if (!match) {
    return trimmed;
  }

  const hours = match[1].padStart(2, '0');
  const minutes = match[2];
  return `${hours}:${minutes}`;
}

export function normalizeTimeValue(value: unknown): string | null {
  if (!value) {
    return null;
  }
  const trimmed = String(value).trim();
  const parts = trimmed.split(':');
  if (parts.length < 2) {
    return null;
  }
  const hours = parts[0].padStart(2, '0');
  const minutes = parts[1].padStart(2, '0');
  return `${hours}:${minutes}`;
}

export function parseTimeToMinutesValue(value: unknown): number | null {
  if (!value || typeof value !== 'string') {
    return null;
  }
  const parts = value.split(':');
  if (parts.length < 2) {
    return null;
  }
  const hours = Number(parts[0]);
  const minutes = Number(parts[1]);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
    return null;
  }
  return hours * 60 + minutes;
}
